<template>
    <el-dialog
        class="report-order"
        :visible.sync="reportOrderVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="580px"
        title="Export data"
        :lock-scroll="false"
        :modal-append-to-body="false"
        append-to-body
    >
        <div class="container">
            <el-form
                ref="reportForm"
                :model="reportForm"
                :rules="rules"
                size="small"
                label-position="top"
            >
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="Search Date" prop="created_at">
                            <el-date-picker
                                v-model="reportForm.created_at"
                                type="daterange"
                                value-format="yyyy-MM-dd"
                                range-separator="-"
                                start-placeholder="Start Date"
                                end-placeholder="End Date"
                                :picker-options="{disabledDate}"
                            >
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="24">
                        <el-form-item label="Export Type">
                            <!-- <el-radio-group v-model="reportForm.type">
                                <el-radio-button label="user">User Details</el-radio-button>
                                <el-radio-button label="store">Store Details</el-radio-button>
                                <el-radio-button label="first_order">First Order Details</el-radio-button>
                            </el-radio-group> -->
                            <el-radio-group v-model="reportForm.type">
                                <el-radio-button label="first_auth_users">First Created Store Users</el-radio-button>
                                <el-radio-button label="first_publish_users">First Published Users</el-radio-button>
                                <el-radio-button label="first_order_users">First Order Users</el-radio-button>
                            </el-radio-group>
                            <el-radio-group v-model="reportForm.type">
                                <el-radio-button label="overview">Summary</el-radio-button>
                                <el-radio-button label="order">Order Analysis</el-radio-button>
                                <el-radio-button label="guide">Guide Details</el-radio-button
                                >
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button
                size="small"
                type="primary"
                :disabled="disabled"
                @click="exportNow"
                :loading="loading"
                >Export</el-button
            >
            <el-button size="small" @click="reportOrderVisible = false"
                >Close</el-button
            >
        </span>
        <generate :generateVisible.sync="generateVisible"></generate>
    </el-dialog>
</template>

<script>
import { cmofferApi } from "@/http/cmofferApi.js";
import { mapActions } from "vuex";
import generate from "@/common/components/generateDialog.vue";
export default {
    components: {
        generate,
    },
    data() {
        return {
            loading: false,
            generateVisible: false,
            checked: true,
            disabled: true,
            reportForm: {
                created_at: [],
                type: ""
            },
        };
    },
    methods: {
        exportNow() {
            this.$refs["reportForm"].validate((valid) => {
                if (valid) {
                    this.loading = true;
                    cmofferApi
                        .reportExport(
                            {
                                ...this.reportForm,
                            },
                            "post"
                        )
                        .then((res) => {
                            // console.log("res: ", res);
                            this.loading = false;
                            if (res.errcode == 0) {
                                this.generateVisible = true;
                                /* this.$message.success(
                                    this.$i18n.locale == "zh"
                                        ? "成功"
                                        : res.errmsg
                                ); */
                            }
                        });
                }
            });
        },
        closeDialog() {
            clearInterval(this.timer);
            this.$refs["reportForm"].clearValidate();
            this.$refs["reportForm"].resetFields();
            this.$emit("update:reportOrderVisible", false);
            this.$parent[this.funcName]();
        },
        disabledDate(date) {
            const today = new Date()
            return date > new Date() || date < new Date(today.getTime() - 3 * 31 * 86400000)
        }
    },
    destroyed() {
        clearInterval(this.timer);
    },
    props: {
        reportOrderVisible: Boolean,
        funcName: String,
    },
    watch: {
        reportOrderVisible() {
            if (this.reportOrderVisible) {
            }
        },
        reportForm: {
            handler(nv) {
                const {created_at, type} = nv
                this.disabled = !(created_at && created_at.length === 2 && created_at[0] && created_at[1] && type)
            },
            immediate: true,
            deep: true
        }
    },
};
</script>

<style lang="scss" scoped>
.report-order {
    ::v-deep .container {
        padding: 1rem 2rem;
        .el-form--label-top {
            .el-row {
                & + .el-row {
                    margin-top: 1rem;
                }

                .el-form-item--small {
                    .el-form-item__label {
                        padding-bottom: 0px;
                        font-weight: bold;
                        font-size: 14px;
                    }
                    .el-radio-group {
                        +.el-radio-group {
                            margin-top: 10px;
                        }
                    }
                }
            }
        }
    }
}
</style>
